var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.90541C1 4.00224 1.35878 3.13606 1.99742 2.49742C2.63606 1.85878 3.50224 1.5 4.40541 1.5H12.6757C13.5788 1.5 14.445 1.85878 15.0837 2.49742C15.7223 3.13606 16.0811 4.00224 16.0811 4.90541V13.1757C16.0811 14.0788 15.7223 14.945 15.0837 15.5837C14.445 16.2223 13.5788 16.5811 12.6757 16.5811H4.40541C3.50224 16.5811 2.63606 16.2223 1.99742 15.5837C1.35878 14.945 1 14.0788 1 13.1757V4.90541Z",
    stroke: "#6E7173",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.39258V13.1764C19 14.8537 18.3337 16.4623 17.1476 17.6483C15.9616 18.8344 14.353 19.5007 12.6757 19.5007H4.89189M1 5.61344H16.0811",
    stroke: "#6E7173",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.c38c59a89eb8bd36333d01c4cf258f31.svg";
export { ForwardRef as ReactComponent };